import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import ConfigApi from '../../library/helpers/configmgmntHelper';
import actions from './action';
export function* dividendAddRequest() {
  yield takeEvery(actions.CONFIG_ADD_NEW, function* ({ payload }) {
    try {
     const result = yield call(ConfigApi.createDividend, payload.dataObj);
     if (!result.success) {
      notification('error', result.message);
    } else {
        notification('success', result.message);
      payload.history.push('/dashboard/dividend-configuration');
  
    }
    yield put(
      actions.configReadSearchSuccess(
        result.data,
        result.message,
        result.success,
        )
    );
    } finally {
      if (payload.callback) payload.callback();
    }
  });
}
export function* configUpdateRequest() {
  yield takeEvery(actions.CONFIG_UPDATE, function* ({ payload }) {
    const result = yield call(ConfigApi.update, payload.configPojo);
    if (!result.success) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
      if(payload.configPojo.config === "langConfig"){
        payload.history.push('admin/configuration/language-configuration');
      }
      if(payload.configPojo.config === "shareConfig"){ 
        payload.history.push('share-configuration');
      }
      if(payload.configPojo.config === "investAcceptConfig"){ 
        payload.history.push('investor-acceptance');
      }
    }
  });
}
export function* configMgmntReadRequest() {
  yield takeEvery([ actions.CONFIGMGMNT_LANG_READ, actions.CONFIGMGMNT_SHARE_READ, actions.CONFIGMGMNT_INVESTOR_READ], function* (action) {
    const { payload, type } = action;
    try {
      let searchResult;
      switch (type) {
        case actions.CONFIGMGMNT_LANG_READ:
          searchResult = yield call(ConfigApi.readLang,payload.readFilter, payload.page); 
          break;

        case actions.CONFIGMGMNT_SHARE_READ:
          searchResult = yield call(ConfigApi.readShare, payload.readFilter, payload.page); 
          break;

        case actions.CONFIGMGMNT_INVESTOR_READ:
          searchResult = yield call(ConfigApi.readInvestor, payload.readFilter, payload.page); 
          break;  

        default:
          break;
      }

      if (searchResult.success) {
        yield put(
          actions.configReadSearchSuccess(
            searchResult.data.result,
            true,
            searchResult.data.totalCount,
            payload.page
          )
        );
      } else {
        notification('error', searchResult.message);
        yield put(
          actions.configReadSearchSuccess({}, false, 0, 0)
        );
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
    }
  });
}
export function* dividendListRequest() {
  yield takeEvery(actions.CONFIGMGMNT_DIV_READ, function* ({ payload }) {
     const result = yield call(ConfigApi.readDividend, payload.page);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.configReadSearchSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* taxListRequest() {
  yield takeEvery(actions.CONFIGMGMNT_TAX_READ, function* ({ payload }) {
     const result = yield call(ConfigApi.readTax, payload.page);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.configReadSearchSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}

export default function* rootSaga() {
  yield all([
    fork(configMgmntReadRequest),
    fork(dividendListRequest),
    fork(taxListRequest),
    fork(configUpdateRequest),
    fork(dividendAddRequest)
  ]);
}